import { useState } from 'react';
import ClassicStatistics from './ClassicStatistics';
import DailyStatistics from './DailyStatistics';

type Config = {
    id: string,
    b: 4 | 5,
    m: 'drag' | 'select'
};
type Props = {
    config: Config,
    dailyId: number,
    setShowStatistics: React.Dispatch<React.SetStateAction<boolean>>,
    visible: boolean
};

const Statistics = ({ config, dailyId, setShowStatistics, visible }: Props): JSX.Element => {
    const [type, setType] = useState<'daily' | 'classic'>('daily');

    return (
        <>
            <div id="statistics-background" onClick={() => setShowStatistics(false)} className={visible ? 'active' : 'hidden'}></div>
            <div id="statistics" className={visible ? 'active' : 'hidden'}>
                <h4>Statistics</h4>
                <div id="statistics-toggles">
                    <div className={`statistics-toggle${type === 'daily' ? ' active' : ''}`} onClick={() => setType('daily')}>Daily</div>
                    <div className={`statistics-toggle${type === 'classic' ? ' active' : ''}`} onClick={() => setType('classic')}>Classic</div>
                </div>
                {type === 'daily' && <DailyStatistics dailyId={dailyId} />}
                {type === 'classic' && <ClassicStatistics />}
                <div id="statistics-user">User Id: {config.id.split('-')[0]}</div>
                <div id="close-menu" onClick={() => setShowStatistics(false)}>x</div>
            </div>
        </>
    );
}

export default Statistics;
